import { MarketLabel } from '@/types';

export const isFavoriteMarket = (market: MarketLabel): boolean => {
	return market === 'favorite';
};

export const isOutrightMarket = (market: MarketLabel): boolean => {
	return market === 'outright';
};

export const isOutrightMarketBySport = (sport: number) => {
	return sport === 999;
};